<style lang="scss" scoped>
.font-20 {
    font-size: 20px;
}
.datasform {
    .ivu-form-item {
        margin-bottom: 10px;
    }
}
.pointer {
    cursor: pointer;
}
.product-title {
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #d01ec2;
    color: #fff;
}
.product-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<template>
    <div class="bg-fff shadow margin-top-20 productForm font-12">
        <header class="product-title font-bold">
            {{
                $t("erp.b2c.product_information", { defaultValue: "产品信息" })
            }}
        </header>
        <div class="clearfix" style="padding-left: 20px">
            <vCol span="6">
                <vButton
                    theme="primary"
                    class="width-50per"
                    v-if="showPullButton && showAllPullButton"
                    @click="pullAll()"
                    >{{
                        tableState
                            ? $t("erp.b2c.product_pull", {
                                  defaultValue: "展开",
                              })
                            : $t("erp.b2c.product_retract", {
                                  defaultValue: "收起",
                              })
                    }}{{
                        $t("erp.b2c.product_all_stock_detail", {
                            defaultValue: "所有库存明细",
                        })
                    }}</vButton
                >
            </vCol>
        </div>
        <div class="padding-20">
            <div
                v-for="(product, proindex) in productList"
                :key="proindex"
                style="border: 1px solid #eee"
            >
                <div
                    class="clearfix"
                    style="background: #f5f5f5; line-height: 36px; height: 36px"
                >
                    <vCol span="24">
                        <vCol span="3">
                            <div style="display: flex; align-items: center">
                                <span
                                    class="padding-left-10 margin-right-10 b2ccolor-dark-primary font-weight"
                                >
                                    {{ product.sellerSku }}
                                </span>
                                <Icon
                                    v-if="alltype != 'query'"
                                    class="font-20 pointer"
                                    type="ios-add-circle"
                                    @click="addItem(proindex)"
                                ></Icon>
                            </div>
                        </vCol>
                        <vCol span="3">
                            <div>
                                ID:<span class="font-weight">{{
                                    product.productsItemId
                                }}</span>
                            </div>
                        </vCol>
                        <vCol span="4">
                            <div>
                                ASIN:<span class="font-weight">{{
                                    product.asin
                                }}</span>
                            </div>
                        </vCol>
                        <vCol span="6">
                            <div>
                                <span
                                    >{{
                                        $t("erp.b2c.confirm_order_amount", {
                                            defaultValue: "下单量",
                                        })
                                    }}:<span class="font-weight">{{
                                        product.quantity
                                    }}</span></span
                                >
                                /
                                <span>
                                    <span
                                        >{{
                                            $t("erp.products.confirm_amount", {
                                                defaultValue: "确认量",
                                            })
                                        }}:</span
                                    >
                                    <span v-if="alltype !== 'query'">
                                        <InputNumber
                                            style="width: 60px"
                                            v-model="product.confirmedQty"
                                            :min="0"
                                            :max="product.quantity"
                                        />
                                    </span>
                                    <span class="font-weight" v-else>
                                        {{ product.confirmedQty }}
                                    </span>
                                </span>
                                <Tooltip
                                    max-width="230"
                                    :content="
                                        $t('erp.b2corder.comfirmqtyTip', {
                                            defaultValue:
                                                '下单量为渠道下单sellersku数量，确认量为实际需要发货sellersku数量，如需要发货量与下单量不一致，请修改确认量',
                                        })
                                    "
                                    ><Icon
                                        type="md-help-circle"
                                        class="color-error"
                                /></Tooltip>
                                <span v-if="product.receivedQuantity != 0">
                                    /
                                    {{
                                        $t("erp.b2c.receive_quantity", {
                                            defaultValue: "接收量",
                                        })
                                    }}:<span class="font-weight">{{
                                        product.receivedQuantity
                                    }}</span></span
                                >
                            </div>
                        </vCol>
                        <!-- <Col span="3">
                            <div style="display: flex;">
                                <div style="margin-right: 5px;">{{$t('erp.products.confirm_amount', { defaultValue: 'confirm数量' })}}:</div>
                                <div v-if="alltype !== 'query'">
                                    <div style="width: 100px;"><InputNumber style="width: 60px;" v-model="product.confirmedQty" :min="0" :max="product.quantity" /></div>
                                </div>
                                <div v-else style="width: 20px;">
                                    {{product.confirmedQty}}
                                </div>
                            </div>
                        </Col> -->
                        <vCol span="4">
                            <div>
                                {{
                                    $t("erp.b2c.money", {
                                        defaultValue: "金额",
                                    })
                                }}:
                                <span
                                    class="font-weight"
                                    v-if="b2cPriceInfo == true"
                                    >{{ product.itemAmount }}
                                    {{ product.currencyCode }}
                                    <span
                                        v-if="
                                            product.channelTotalSalesAmount > 0
                                        "
                                        >(<span style="color: red"
                                            >{{
                                                product.channelTotalSalesAmount.toFixed(
                                                    2
                                                )
                                            }}
                                            {{ product.currencyCode }}</span
                                        >)</span
                                    ></span
                                >
                                <span v-else>--</span>
                            </div>
                        </vCol>
                        <vCol span="3">
                            <div style="text-align: right">
                                <span
                                    v-if="product.isShip == 'automatic'"
                                    class="light-primary span-padding line-24"
                                    >{{
                                        $t("erp.b2c.product_delivery", {
                                            defaultValue: "发货产品",
                                        })
                                    }}</span
                                >
                                <span
                                    v-else
                                    class="b2cspan-error span-padding line-24"
                                    >{{
                                        $t("erp.b2c.noproduct_delivery", {
                                            defaultValue: "不发货产品",
                                        })
                                    }}</span
                                >
                            </div>
                        </vCol>
                    </vCol>
                </div>

                <table class="width-100per">
                    <tr>
                        <td
                            class="width-30per"
                            style="border-right: 1px solid #ddd"
                        >
                            <div
                                class="padding-left-10"
                                v-if="fulfillmentChannel == 'AFN'"
                            >
                                {{ product.erpSku || "--" }}
                            </div>
                            <div
                                class="margin-left-10 padding-top-10 datasform clearfix"
                                v-for="(
                                    item, itemindex
                                ) in product.orderItemList"
                                :key="itemindex"
                            >
                                <div
                                    style="
                                        height: 35px;
                                        display: flex;
                                        align-items: center;
                                    "
                                >
                                    <div class="pull-left">
                                        <Icon
                                            v-if="alltype != 'query'"
                                            class="font-14 pointer"
                                            type="md-close"
                                            @click="
                                                delectItem(proindex, itemindex)
                                            "
                                        ></Icon>
                                    </div>
                                    <div
                                        style="width: 150px"
                                        class="pull-left"
                                        :class="{
                                            'margin-left-20': alltype == 'edit',
                                        }"
                                    >
                                        <span
                                            v-if="alltype == 'query'"
                                            class="b2ccolor-dark-primary font-weight"
                                            >{{ item.erpSku }}</span
                                        >
                                        <Select
                                            v-else
                                            clearable
                                            filterable
                                            v-model="item.erpSku"
                                            ref="zierpselect"
                                            remote
                                            :remote-method="remoteMethod1"
                                            :loading="loading1"
                                            @on-change="
                                                operateList(
                                                    proindex,
                                                    itemindex,
                                                    product.orderItemList
                                                )
                                            "
                                        >
                                            <Option
                                                v-for="json in erpSkusList"
                                                :value="json.name"
                                                :key="json.id"
                                                >{{ json.name }}</Option
                                            >
                                        </Select>
                                    </div>
                                    <div
                                        style="width: 60px; margin-right: 10px"
                                        class="pull-left margin-left-20"
                                    >
                                        <span v-if="alltype == 'query'"
                                            >✖
                                            <!-- <div class="circle"> -->
                                            <span
                                                class="b2ccolor-error font-weight numberSpan"
                                                >{{ item.quantity }}</span
                                            >
                                            <!-- </div> -->
                                        </span>
                                        <InputNumber
                                            v-else
                                            :min="1"
                                            v-model="item.quantity"
                                        ></InputNumber>
                                    </div>
                                    <div
                                        style="width: 120px"
                                        class="pull-left margin-left-40"
                                        v-if="isShowInsurance"
                                    >
                                        <span
                                            v-if="alltype == 'query'"
                                            v-show="item.insuranceAmount > 0"
                                        >
                                            <span class="font-weight"
                                                >{{
                                                    $t("erp.b2c.insure_price", {
                                                        defaultValue:
                                                            "投保单价",
                                                    })
                                                }}
                                                {{ item.insuranceAmount }}
                                                {{ product.currencyCode }}</span
                                            >
                                        </span>
                                        <Input
                                            v-else
                                            v-model="item.showInsuranceAmount"
                                            :placeholder="
                                                $t('erp.b2c.insure_price', {
                                                    defaultValue: '投保单价',
                                                })
                                            "
                                            style="width: 80px"
                                            @on-change="
                                                changeInsuranceAmount(item)
                                            "
                                        ></Input>
                                        <Tooltip
                                            v-if="alltype != 'query'"
                                            :content="
                                                $t('erp.b2c.insure_price', {
                                                    defaultValue: '投保单价',
                                                })
                                            "
                                            placement="top"
                                            ><Icon
                                                style="vertical-align: middle"
                                                type="information-circled"
                                                class="font-20"
                                        /></Tooltip>
                                    </div>
                                    <!-- <div style="width:20px;" v-show="orgId==1" class="pull-left margin-left-20">
                                        <Tooltip content='查看虚拟库存' placement="top">
                                            <Icon type="ios-paper-outline" style="font-size: x-large;" @click="getStock(item.erpSku,itemindex,channelFlag,orgId)"></Icon>
                                        </Tooltip>
                                    </div> -->
                                    <div
                                        style="width: 50px"
                                        v-show="orgId == 1 || orgId == 1000049"
                                        class="pull-left margin-left-20"
                                    >
                                        <Tooltip
                                            :content="item.iconText"
                                            placement="top"
                                        >
                                            <Icon
                                                type="ios-paper-outline"
                                                v-if="showAllPullButton"
                                                style="font-size: x-large"
                                                @click="pullButton(item)"
                                            ></Icon>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div>
                                    <span v-if="alltype == 'query'">{{
                                        item.title
                                    }}</span>
                                    <span
                                        v-else-if="
                                            alltype == 'edit' && item.title
                                        "
                                        >{{ item.title }}</span
                                    >
                                    <div
                                        v-else-if="
                                            alltype == 'edit' && !item.title
                                        "
                                    >
                                        <span>{{
                                            item.erpSku
                                                | filterErpsku(
                                                    "name",
                                                    erpSkusList,
                                                    itemindex,
                                                    product.orderItemList
                                                )
                                        }}</span>
                                    </div>
                                </div>
                                <div>
                                    <Table
                                        v-show="item.showTable"
                                        class="margin-top-20 margin-right-10 margin-bottom-10"
                                        :loading="loadingtabel"
                                        :columns="columns"
                                        :data="item.showList"
                                        size="small"
                                        ref="table"
                                        border
                                    ></Table>
                                </div>
                            </div>
                        </td>
                        <td
                            style="border-right: 1px solid #ddd"
                            class="padding-left-10 width-15per"
                        >
                            <div
                                :title="
                                    product.lineId
                                        | transferText('name', products)
                                "
                                class="product-name"
                            >
                                {{
                                    $t("global.common.line", {
                                        defaultValue: "项目",
                                    })
                                }}:
                                <span
                                    v-if="product.lineId != 0"
                                    class="b2ccolor-warning font-weight span-padding line-24"
                                >
                                    {{
                                        product.lineId
                                            | transferText("name", products)
                                    }}
                                </span>
                                <span v-else> -- </span>
                            </div>
                        </td>
                        <td
                            style="border-right: 1px solid #ddd"
                            class="padding-left-10 width-15per"
                        >
                            <div>
                                {{
                                    $t("erp.b2c.freight", {
                                        defaultValue: "运费",
                                    })
                                }}:
                                <span
                                    class="font-weight"
                                    v-if="b2cPriceInfo == true"
                                    >{{ product.shippingPrice }}
                                    {{ product.currencyCode }}</span
                                >
                                <span v-else>--</span>
                            </div>
                            <div>
                                {{
                                    $t("erp.b2c.taxes_fees", {
                                        defaultValue: "税费",
                                    })
                                }}:
                                <span
                                    class="font-weight"
                                    v-if="b2cPriceInfo == true"
                                    >{{ product.taxPrice }}
                                    {{ product.currencyCode }}</span
                                >
                                <span v-else>--</span>
                            </div>
                        </td>
                        <td
                            style="border-right: 1px solid #ddd"
                            class="padding-left-10 width-15per"
                        >
                            <div>
                                FOB:
                                <span
                                    class="font-weight"
                                    v-if="b2cPriceInfo == true"
                                    >{{ product.itemCost }}
                                    {{
                                        product.costCurrency
                                            ? product.costCurrency
                                            : product.currencyCode
                                    }}</span
                                >
                                <span v-else>--</span>
                            </div>
                            <div>
                                DDP:
                                <span
                                    class="font-weight"
                                    v-if="b2cPriceInfo == true"
                                    >{{ product.ddpCost }}
                                    {{
                                        product.costCurrency
                                            ? product.costCurrency
                                            : product.currencyCode
                                    }}</span
                                >
                                <span v-else>--</span>
                            </div>
                        </td>
                        <td class="padding-left-10 width-25per">
                            <div class="product-name">
                                Tracking:
                                <span
                                    class="b2ccolor-success font-weight"
                                    v-if="product.trackNo"
                                >
                                    [{{ product.shippingMethodCode }}]{{
                                        product.trackNo
                                    }}
                                </span>
                                <span v-else> -- </span>
                            </div>
                            <div>
                                {{
                                    $t("erp.b2c.discount_number", {
                                        defaultValue: "折扣号",
                                    })
                                }}:
                                <span
                                    class="font-weight"
                                    v-if="product.promotionIds"
                                >
                                    {{ product.promotionIds }}
                                </span>
                                <span v-else> -- </span>
                            </div>
                            <div>
                                {{
                                    $t("erp.b2c.discount_amount", {
                                        defaultValue: "折扣金额",
                                    })
                                }}:
                                <span
                                    class="font-weight"
                                    v-if="b2cPriceInfo == true"
                                >
                                    {{ product.promotionDiscountPrice }}
                                    {{ product.promotionDiscountCurrencyCode }}
                                </span>
                                <span v-else>--</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <!--<Modal v-model="operate.show" width="600" @on-cancel="close('all')">
            <div class="headercss">
                <p>{{operate.title}}</p>
            </div>
            <div style="margin-top:15px">
                <span>&nbsp;&nbsp;&nbsp;ERP SKU: {{operate.data.erpsku}} &nbsp;&nbsp;&nbsp;可用库存总量 {{operate.data.totalQty}} </span>

            </div>
            <div slot="footer" v-show="false">
            </div>

        </Modal>-->
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { HttpProductErpSku } from "@/service/boss/dictionary";
import { HttpVsSkuList } from "@/service/boss/allot";
import { HttpB2cgetVirtualInventoryDetail } from "@/service/boss/b2corder";
export default {
    props: [
        "comProduct",
        "alltype",
        "fulfillmentChannel",
        "orgId",
        "channelFlag",
        "isInsurance",
    ],
    watch: {
        // 重新构造一个productList数组
        comProduct: {
            deep: true,
            immediate: true,
            handler(val) {
                if (val) {
                    let erpskuArr = [];
                    if (!val || val.length === 0) {
                        this.showAllPullButton = false;
                    } else {
                        val.map((item) => {
                            if (
                                !item.orderItemList ||
                                item.orderItemList.length === 0
                            ) {
                                erpskuArr.push(item.productsItemId);
                            }
                        });
                    }
                    // console.log(erpskuArr.length, val.length)
                    if (erpskuArr.length === val.length) {
                        this.showAllPullButton = false;
                    } else {
                        this.showAllPullButton = true;
                    }
                    this.$forceUpdate();
                    // console.log(this.showPullButton, this.showAllPullButton)
                    this.productList = val.map((item) => {
                        let orderItemList = [];
                        if (
                            item.orderItemList &&
                            item.orderItemList.length > 0
                        ) {
                            orderItemList = item.orderItemList.map((sItem) => {
                                return {
                                    ...sItem,
                                    showInsuranceAmount:
                                        sItem.insuranceAmount === 0
                                            ? ""
                                            : sItem.insuranceAmount,
                                    // iconType: 'chevron-up',
                                    iconText: this.$t(
                                        "erp.b2c.product_pull_stock_detail",
                                        { defaultValue: "展开库存明细" }
                                    ),
                                    showTable: false,
                                    hasData: false,
                                    formList: [],
                                    showList: [],
                                };
                            });
                        }
                        return {
                            ...item,
                            orderItemList: orderItemList,
                        };
                    });
                }
                console.log(this.productList);
            },
        },
        isInsurance: {
            immediate: true,
            handler(val) {
                this.isShowInsurance = val;
            },
        },
    },
    data() {
        return {
            erpSkusList: [],
            loading1: false,
            loadingtabel: false,
            erpskutitle: "",
            filtertitle: "",
            b2cPriceInfo: false,
            productList: [],
            operate: {
                // loading:true,
                show: false,
                title: "",
                data: {
                    erpsku: "",
                    totalQty: 0,
                },
            },
            tableState: 1,
            isShowInsurance: false,
            showPullButton: false,
            showAllPullButton: true,
        };
    },
    created() {
        this.b2cPriceInfo = this.handleAuth("erp.b2cOrder.indexPrice");
    },
    mounted() {
        // bizark和傲飞斯才展示展开库存明细
        if (global.SYSID === 1 || global.SYSID === 1000049) {
            this.showPullButton = true;
        }
    },
    computed: {
        ...mapState("boss", ["products"]),
        ...mapGetters("boss", ["warehouses"]),
        columns() {
            return [
                {
                    title: this.$t("erp.b2c.product_orgwarehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "orgWarehou",
                },
                {
                    title: this.$t("erp.b2c.product_valuestock", {
                        defaultValue: "可用库存",
                    }),
                    key: "qty",
                },
            ];
        },
    },
    methods: {
        // 跟随改变
        changeInsuranceAmount(item) {
            item.insuranceAmount = item.showInsuranceAmount;
        },
        // 点击展开/收起按钮
        pullButton(item, isAll = false) {
            // 是否全部展开/收起
            if (isAll) {
                if (this.tableState === 0) {
                    item.showTable = false;
                } else {
                    item.showTable = true;
                }
            } else {
                item.showTable = !item.showTable;
            }
            // 展开时
            if (item.showTable) {
                item.iconText = this.$t(
                    "erp.b2c.product_retract_stock_detail",
                    { defaultValue: "收起库存明细" }
                );
                // item.iconType = 'chevron-up'
                // 编辑时，不缓存数据，展开一次调一次接口
                if (this.alltype !== "query") {
                    this.getStock(item.erpSku);
                }
                // 查看时缓存数据，第一次获取数据后组件重新渲染后才会再次调用接口
                else if (!item.hasData) {
                    item.hasData = true;
                    this.getStock(item.erpSku);
                }
            }
            // 收起时
            else {
                item.iconText = this.$t("erp.b2c.product_pull_stock_detail", {
                    defaultValue: "展开库存明细",
                });
                // item.iconType = 'chevron-down'
            }
            // 判断是否所有的都已展开/已收起
            let judArr = [];
            this.productList.map((item) => {
                if (item.orderItemList) {
                    item.orderItemList.map((sItem) => {
                        judArr.push(sItem.showTable);
                    });
                }
            });
            // 利用set去重判断是否所有的都是同一状态
            if (new Set(judArr).size === 1) {
                if (judArr[0]) {
                    this.tableState = 0;
                } else {
                    this.tableState = 1;
                }
            }
        },
        // 全部展开/收起
        pullAll() {
            this.productList.map((item) => {
                if (item.orderItemList) {
                    item.orderItemList.map((sItem) => {
                        this.pullButton(sItem, true);
                    });
                }
            });
        },
        async getStock(erpSku) {
            if (!erpSku) {
                return;
            }
            // this.loadingtabel = true;
            await HttpB2cgetVirtualInventoryDetail({
                erpsku: erpSku,
                channelFlag: this.channelFlag,
            }).then(
                (res) => {
                    // this.operate.data = {erpsku: erpsku, totalQty: res.data.totalQty};
                    // this.loadingtabel = false;
                    if (
                        res.data.orgWarehouseQty != null &&
                        res.data.orgWarehouseQty != ""
                    ) {
                        let dataList = [];
                        let showList = [];
                        let count = 0;
                        this.warehouses.map((item) => {
                            if (item.active === 0) return;
                            let warehouFormList = {};
                            if (
                                res.data.orgWarehouseQty[item.id] != undefined
                            ) {
                                let warehouFormList = {
                                    orgWarehou:
                                        item.title + "[" + item.code + "]",
                                    qty: res.data.orgWarehouseQty[item.id],
                                };
                                count += res.data.orgWarehouseQty[item.id];
                                dataList.push(warehouFormList);
                                showList.push(warehouFormList);
                            }
                        });

                        showList.push({
                            orgWarehou: this.$t("erp.b2c.product_totalcount", {
                                defaultValue: "合计",
                            }),
                            qty: count,
                        });
                        let erpskuArr = [];
                        this.productList = this.productList.map((item) => {
                            erpskuArr.push(item.erpSku);
                            if (
                                item.orderItemList &&
                                item.orderItemList.length > 0
                            ) {
                                item.orderItemList = item.orderItemList.map(
                                    (sItem) => {
                                        if (erpSku === sItem.erpSku) {
                                            return {
                                                ...sItem,
                                                formList: dataList,
                                                showList: showList,
                                            };
                                        } else {
                                            return sItem;
                                        }
                                    }
                                );
                            }
                            return item;
                        });
                    }
                },
                (err) => {
                    // this.loadingtabel = false;
                    this.errorMessage(err.message);
                }
            );
        },
        operateList(proindex, index, list) {
            list[index].title = "";
            // list[index].quantity = 0;
            list[index].productId = "";
            list[index].insuranceAmount = 0;
            if (this.productList[proindex].orderItemList[index].showTable) {
                if (!this.productList[proindex].orderItemList[index].erpSku) {
                    return (this.productList[proindex].orderItemList[
                        index
                    ].formList = []);
                }
                this.getStock(
                    this.productList[proindex].orderItemList[index].erpSku
                );
            }
        },
        remoteMethod1(query) {
            this.loading1 = true;
            HttpVsSkuList({
                page: 1,
                rows: 100,
                "search[CN_erpSku]": query,
            }).then((res) => {
                // console.log(res)
                this.loading1 = false;
                this.erpSkusList = res.data.content.map((item) => {
                    return {
                        name: item.erpSku,
                        id: item.id,
                        title: item.nameEn,
                    };
                });
            });
        },
        addItem(index) {
            let data = {
                erpSku: "",
                quantity: 1,
                title: "",
                productId: "",
                insuranceAmount: 0,
                showInsuranceAmount: "",
                iconText: this.$t("erp.b2c.product_pull_stock_detail", {
                    defaultValue: "展开库存明细",
                }),
                showTable: false,
                hasData: false,
                formList: [],
            };
            if (this.productList[index].orderItemList) {
                this.productList[index].orderItemList.push(data);
            } else {
                this.productList[index].orderItemList = [];
                this.productList[index].orderItemList.push(data);
            }
            // console.log(this.comProduct[index].orderItemList)
        },
        delectItem(proindex, itemindex) {
            this.productList[proindex].orderItemList.splice(itemindex, 1);
        },
        close(val) {
            // console.log(val)
            switch (val) {
                case "all":
                    this.operate.show = false;
                    break;
            }
        },
        // getStock(erpsku, flag ,orgId) {
        //     this.loadingtabel = true;
        //     this.formList = []
        //     this.operate = {
        //         title: '虚拟库存',
        //         show:true,
        //         width:2000,
        //         data:{
        //             erpsku:"",
        //             totalQty: 0
        //         },
        //     }
        //     HttpB2cgetVirtualInventoryDetail({
        //         erpsku: erpsku,
        //         channelFlag: flag
        //     }).then(res => {
        //         this.operate.data = {erpsku: erpsku, totalQty: res.data.totalQty};
        //         this.loadingtabel = false;
        //         if (res.data.orgWarehouseQty != null && res.data.orgWarehouseQty != "") {
        //             this.warehouses.map(item=>{
        //                 let warehouFormList = {}
        //                 if (res.data.orgWarehouseQty[item.id] != undefined) {
        //                     let warehouFormList = {orgWarehou:item.title+'['+item.code+']',qty:res.data.orgWarehouseQty[item.id]};
        //                     this.formList.push(warehouFormList)
        //                 }
        //             });
        //         }
        //     }, err => {
        //         this.errorMessage(err.message);
        //     });

        // }
    },
    filters: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach((item) => {
                if (item[key] === val) {
                    text = item[textKey];
                }
            });
            return text;
        },
        filterErpsku(val, textKey, list = [], index, list2 = []) {
            let text = "",
                pid = "";
            list.forEach((item) => {
                if (item.name === val) {
                    text = item.title;
                    pid = item.id;
                }
            });
            list2[index].title = text;
            list2[index].productId = pid;
            return text;
        },
    },
};
</script>
